const poolData = {
  UserPoolId: 'eu-west-1_gWkeN5EhU',
  ClientId: '7t6r96ottf54sp8m68hgbh32gq'
}
export default {
  poolData
}